import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

export default class DropDownComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.children !== prevProps.children) this.setState({ dropdownOpen: false });
  }

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  render() {
    const { children, title } = this.props;
    const { dropdownOpen } = this.state;
    const toggleBtnStyle = dropdownOpen ? 'text-white' : 'bg-white';

    return (
      <Dropdown isOpen={dropdownOpen} toggle={this.toggle} className="d-inline">
        <DropdownToggle className={`category-item px-3 ${toggleBtnStyle}`}>{title}</DropdownToggle>
        <DropdownMenu className="category-dropdown-container">
          <div className="p-2 category-dropdown-menu mt-0">{children}</div>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

DropDownComponent.propTypes = {
  title: PropTypes.string,
  children: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/List/Dropdown.js